<template>
  <div class="login">
    <div class="login-card">
      <h1>Cuxa Anastylose</h1>
      <p class="subtitle">Accès à la plateforme</p>
      <form @submit.prevent="submit" class="login-form">
        <label for="password">Mot de passe</label>
        <input
          id="password"
          v-model="password"
          type="password"
          autocomplete="current-password"
          placeholder="Mot de passe"
          required
        />
        <p v-if="error" class="error">{{ error }}</p>
        <button type="submit" class="btn-primary" :disabled="loading">
          {{ loading ? 'Connexion...' : 'Accéder' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from '@stores/auth.store';

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const password = ref('');
const error = ref('');
const loading = ref(false);

onMounted(async () => {
  const required = await authStore.fetchStatus();
  if (!required) {
    redirect();
    return;
  }
  if (authStore.isAuthenticated) redirect();
});

function redirect() {
  const r = route.query.redirect;
  router.replace(typeof r === 'string' ? r : '/');
}

async function submit() {
  error.value = '';
  loading.value = true;
  try {
    const result = await authStore.login(password.value);
    if (result.ok) redirect();
    else error.value = result.error || 'Erreur';
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1a1a1a;
}

.login-card {
  width: 100%;
  max-width: 360px;
  padding: 2rem;
  background-color: #252525;
  border: 1px solid #333;
  border-radius: 8px;
}

.login-card h1 {
  font-size: 1.5rem;
  margin-bottom: 0.25rem;
  color: #e0e0e0;
}

.subtitle {
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.login-form label {
  display: block;
  font-size: 0.85rem;
  color: #bbb;
  margin-bottom: 0.5rem;
}

.login-form input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #1a1a1a;
  border: 1px solid #444;
  border-radius: 4px;
  color: #e0e0e0;
  font-size: 1rem;
}

.login-form input:focus {
  outline: none;
  border-color: #4a9eff;
}

.error {
  color: #dc3545;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.btn-primary {
  width: 100%;
  padding: 0.75rem;
  background-color: #4a9eff;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background-color: #3a8eef;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
